export default __webpack_public_path__ + "static/homepage-feature-34c1d4320fc649fc60a1d98fa55c5430.jpg";